export function isRealtimeUpgradeRequired(errorOrMessage) {
  const code =
    typeof errorOrMessage === "object" && errorOrMessage
      ? errorOrMessage.code || errorOrMessage.response?.data?.code
      : null;
  if (code === "ENTITLEMENT_EXHAUSTED") return true;

  const message =
    typeof errorOrMessage === "string"
      ? errorOrMessage
      : errorOrMessage?.error ||
        errorOrMessage?.message ||
        errorOrMessage?.response?.data?.error ||
        "";

  const normalized = String(message).toLowerCase();
  return (
    normalized.includes("no remaining realtime minutes") ||
    normalized.includes("no remaining time left") ||
    normalized.includes("out of minutes for today")
  );
}

export function realtimeUpgradeMessage(errorOrMessage) {
  const message =
    typeof errorOrMessage === "string"
      ? errorOrMessage
      : errorOrMessage?.error ||
        errorOrMessage?.message ||
        errorOrMessage?.response?.data?.error ||
        "";
  const normalized = String(message).toLowerCase();

  if (normalized.includes("out of minutes for today")) {
    return "You're out of minutes for today. You'll get more time tomorrow, or upgrade to Elite.";
  }

  return "You have no remaining time left. Upgrade to keep practicing.";
}
